export const ID = 'c26ebc1c-26f5-42e8-b4ee-aa510f6f1e73';

export const NAME = 'StorageMart Rental Summary';
